import configuration from "../../configuration";
import ODataFulogicsStore from "fulogics-ui-core/dist/api/odata/ODataFulogicsStore";
import {createModel} from "@rematch/core";
import {iRootModel} from "../iRootModel";

export const CarrierTypesODataEndpoint = `${configuration.API_BASE_URL}/odata/CarrierTypes/Store`;
export const CarrierTypesStore = ODataFulogicsStore({
    url: CarrierTypesODataEndpoint,
    key: 'id',
    keyType: 'String'
});

export type CarrierTypesState = {

}

export const CarrierTypesModel = createModel<iRootModel>()({
    state: {
        //store: CarrierTypesStore
    } as CarrierTypesState,

    effects: (dispatch) => ({

    }),

    // @ts-ignore
    selectors: (slice, createSelector, hasProps) => ({
        dxStore() {
            return CarrierTypesStore;
        }
    }),
})

export default CarrierTypesModel;